import { useParams } from 'react-router-dom'
import { useCallback, useContext, useEffect } from 'react'

// others
import { ActionType } from '../context/AppContextReducer'
import { AppContext } from '../context'

// component import
import { ChartsOfAccounts } from '../components/accounts/chartsofAccounts'
import JournalEntries from '../pages/main/accounting/journalEntries/JournalEntries'
import { JournalEntriesContextProvider } from '../context/JournalEntriesContext'
import Payments from '../components/accounts/payments'
import AccountsReceivable from '../pages/main/accounting/accountsReceivable/AccountsReceivable'
import { AccountsReceivableContextProvider } from '../context/AccountsReceivableContext'
import AccountPayable from '../components/accounts/accountPayables/AccountPayables'
import GeneralLedger from '../components/accounts/generalLedger'

export const AccountsContainer = () => {
  const { dispatch: reducerDispatch } = useContext(AppContext)
  const { page } = useParams()
  const upperCaseType = page?.toLocaleUpperCase()

  const getPage = useCallback(() => {
    switch (upperCaseType) {
      case 'ACCOUNTS':
        return <ChartsOfAccounts />
      case 'RECEIVABLES':
        return (
          <AccountsReceivableContextProvider>
            <AccountsReceivable />
          </AccountsReceivableContextProvider>
        )
      case 'PAYABLE':
        return <AccountPayable />
      case 'PAYMENTS':
        return <Payments />
      case 'JOURNALS':
        return (
          <JournalEntriesContextProvider>
            <JournalEntries />
          </JournalEntriesContextProvider>
        )
      case 'LEDGER':
        return <GeneralLedger />
      default:
        return <ChartsOfAccounts />
    }
  }, [upperCaseType])

  useEffect(() => {
    return () => {
      reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <>{getPage()}</>
}
